import _ from 'lodash'

export const useShesfreaky = () => {
	const {getFileNameFromUrl, extFetch} = useHelpers()

	/**
	 * Extract video URL from shesfreaky page
	 */
	async function getVideoFromUrl(url) {
		try {
			// If it's already a direct video URL, return it
			if (url.match(/\.(mp4|webm|m3u8)(\?|$)/i)) {
				return {
					website: 'shesfreaky.com',
					type: 'video',
					url: url,
					fileName: getFileNameFromUrl(url) || 'video.mp4',
					previewUrl: url,
					thumbnail: null,
					canView: true
				}
			}

			// Fetch the page and extract video URL
			try {
				let response = await extFetch(url, {
					method: 'GET',
					headers: {
						'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36',
						'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8',
						'Accept-Language': 'en-US,en;q=0.9',
						'Connection': 'keep-alive',
					}
				})

				if (response && response.body) {
					let html = typeof response.body === 'string' ? response.body : (response.body.toString ? response.body.toString() : String(response.body))

					// Extract video URL from video tag with id "video-id"
					let videoUrlMatch = html.match(/<video id="video-id">.*?<source src="(.*?)"/s) ||
										 html.match(/<video id=\\"video-id\\">.*?<source src=\\"(.*?)\\"/s)

					if (!videoUrlMatch) {
						// Fallback to broader search if specific tag not found
						const broadMatch = html.match(/https:\/\/[^"']+?\.mjedge\.net\/videos\/[^"']+?\.mp4\?[^"']+?token=[^"']+/)
						if (!broadMatch) {
							console.error('Could not find video URL in page source.')
							return {
								website: 'shesfreaky.com',
								type: 'video',
								url: url,
								fileName: 'video.mp4',
								previewUrl: url,
								thumbnail: null,
								canView: false,
								error: 'Could not find video URL in page source'
							}
						}
						videoUrlMatch = [null, broadMatch[0]]
					}

					const videoUrl = videoUrlMatch[1].replace(/&amp;/g, '&').replace(/\\/g, '')

					return {
						website: 'shesfreaky.com',
						type: 'video',
						url: videoUrl,
						fileName: 'video.mp4',
						previewUrl: videoUrl,
						thumbnail: null,
						canView: true,
						referer: 'https://www.shesfreaky.com/'
					}
				}
			} catch (fetchError) {
				console.warn('Could not fetch shesfreaky page to extract video URL:', fetchError)
			}

			// Fallback: return the original URL as-is
			return {
				website: 'shesfreaky.com',
				type: 'video',
				url: url,
				fileName: getFileNameFromUrl(url) || 'video.mp4',
				previewUrl: url,
				thumbnail: null,
				canView: true
			}
		} catch (error) {
			console.error('Error fetching shesfreaky video from URL:', error)
			return {
				website: 'shesfreaky.com',
				type: 'video',
				url: url,
				fileName: getFileNameFromUrl(url) || 'video.mp4',
				previewUrl: url,
				thumbnail: null,
				canView: true
			}
		}
	}

	async function getVideosFromUrls(urls) {
		let validUrls = urls
			.split('\n')
			.map(url => url.trim())
			.filter(url => url && url.length > 0)

		const CONCURRENCY = 5
		const results = new Array(validUrls.length)
		let nextIndex = 0

		const worker = async () => {
			while (nextIndex < validUrls.length) {
				const idx = nextIndex++
				results[idx] = await getVideoFromUrl(validUrls[idx])
			}
		}

		await Promise.all(
			Array.from({length: Math.min(CONCURRENCY, validUrls.length)}, () => worker())
		)

		return results.map((media, index) => ({
			...media,
			id: `shesfreaky-${Date.now()}-${index}`,
			source: 'shesfreaky'
		}))
	}

	return {
		getMedia: async (form) => {
			if (form.urls) return getVideosFromUrls(form.urls)
			if (form.url) {
				let media = await getVideoFromUrl(form.url)
				media.id = `shesfreaky-${Date.now()}`
				media.source = 'shesfreaky'
				return [media]
			}
			return []
		},
		getVideoFromUrl,
		getVideosFromUrls
	}
}